
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire73bb"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire73bb"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l7VLp", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6170f1a08d72585$export$2e2bcd8739ae039);
/**
 * @module ol/geom/Circle
 */ 
var $h7zsK = parcelRequire("h7zsK");

var $9pD6L = parcelRequire("9pD6L");

var $9bJty = parcelRequire("9bJty");

var $1MAUi = parcelRequire("1MAUi");
/**
 * @classdesc
 * Circle geometry.
 *
 * @api
 */ class $f6170f1a08d72585$var$Circle extends (0, $h7zsK.default) {
    /**
   * @param {!import("../coordinate.js").Coordinate} center Center.
   *     For internal use, flat coordinates in combination with `layout` and no
   *     `radius` are also accepted.
   * @param {number} [radius] Radius in units of the projection.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   */ constructor(center, radius, layout){
        super();
        if (layout !== undefined && radius === undefined) this.setFlatCoordinates(layout, center);
        else {
            radius = radius ? radius : 0;
            this.setCenterAndRadius(center, radius, layout);
        }
    }
    /**
   * Make a complete copy of the geometry.
   * @return {!Circle} Clone.
   * @api
   */ clone() {
        const circle = new $f6170f1a08d72585$var$Circle(this.flatCoordinates.slice(), undefined, this.layout);
        circle.applyProperties(this);
        return circle;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @param {import("../coordinate.js").Coordinate} closestPoint Closest point.
   * @param {number} minSquaredDistance Minimum squared distance.
   * @return {number} Minimum squared distance.
   */ closestPointXY(x, y, closestPoint, minSquaredDistance) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        const squaredDistance = dx * dx + dy * dy;
        if (squaredDistance < minSquaredDistance) {
            if (squaredDistance === 0) for(let i = 0; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            else {
                const delta = this.getRadius() / Math.sqrt(squaredDistance);
                closestPoint[0] = flatCoordinates[0] + delta * dx;
                closestPoint[1] = flatCoordinates[1] + delta * dy;
                for(let i = 2; i < this.stride; ++i)closestPoint[i] = flatCoordinates[i];
            }
            closestPoint.length = this.stride;
            return squaredDistance;
        }
        return minSquaredDistance;
    }
    /**
   * @param {number} x X.
   * @param {number} y Y.
   * @return {boolean} Contains (x, y).
   */ containsXY(x, y) {
        const flatCoordinates = this.flatCoordinates;
        const dx = x - flatCoordinates[0];
        const dy = y - flatCoordinates[1];
        return dx * dx + dy * dy <= this.getRadiusSquared_();
    }
    /**
   * Return the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @return {import("../coordinate.js").Coordinate} Center.
   * @api
   */ getCenter() {
        return this.flatCoordinates.slice(0, this.stride);
    }
    /**
   * @param {import("../extent.js").Extent} extent Extent.
   * @protected
   * @return {import("../extent.js").Extent} extent Extent.
   */ computeExtent(extent) {
        const flatCoordinates = this.flatCoordinates;
        const radius = flatCoordinates[this.stride] - flatCoordinates[0];
        return (0, $9pD6L.createOrUpdate)(flatCoordinates[0] - radius, flatCoordinates[1] - radius, flatCoordinates[0] + radius, flatCoordinates[1] + radius, extent);
    }
    /**
   * Return the radius of the circle.
   * @return {number} Radius.
   * @api
   */ getRadius() {
        return Math.sqrt(this.getRadiusSquared_());
    }
    /**
   * @private
   * @return {number} Radius squared.
   */ getRadiusSquared_() {
        const dx = this.flatCoordinates[this.stride] - this.flatCoordinates[0];
        const dy = this.flatCoordinates[this.stride + 1] - this.flatCoordinates[1];
        return dx * dx + dy * dy;
    }
    /**
   * Get the type of this geometry.
   * @return {import("./Geometry.js").Type} Geometry type.
   * @api
   */ getType() {
        return "Circle";
    }
    /**
   * Test if the geometry and the passed extent intersect.
   * @param {import("../extent.js").Extent} extent Extent.
   * @return {boolean} `true` if the geometry and the extent intersect.
   * @api
   */ intersectsExtent(extent) {
        const circleExtent = this.getExtent();
        if ((0, $9pD6L.intersects)(extent, circleExtent)) {
            const center = this.getCenter();
            if (extent[0] <= center[0] && extent[2] >= center[0]) return true;
            if (extent[1] <= center[1] && extent[3] >= center[1]) return true;
            return (0, $9pD6L.forEachCorner)(extent, this.intersectsCoordinate.bind(this));
        }
        return false;
    }
    /**
   * Set the center of the circle as {@link module:ol/coordinate~Coordinate coordinate}.
   * @param {import("../coordinate.js").Coordinate} center Center.
   * @api
   */ setCenter(center) {
        const stride = this.stride;
        const radius = this.flatCoordinates[stride] - this.flatCoordinates[0];
        const flatCoordinates = center.slice();
        flatCoordinates[stride] = flatCoordinates[0] + radius;
        for(let i = 1; i < stride; ++i)flatCoordinates[stride + i] = center[i];
        this.setFlatCoordinates(this.layout, flatCoordinates);
        this.changed();
    }
    /**
   * Set the center (as {@link module:ol/coordinate~Coordinate coordinate}) and the radius (as
   * number) of the circle.
   * @param {!import("../coordinate.js").Coordinate} center Center.
   * @param {number} radius Radius.
   * @param {import("./Geometry.js").GeometryLayout} [layout] Layout.
   * @api
   */ setCenterAndRadius(center, radius, layout) {
        this.setLayout(layout, center, 0);
        if (!this.flatCoordinates) this.flatCoordinates = [];
        /** @type {Array<number>} */ const flatCoordinates = this.flatCoordinates;
        let offset = (0, $9bJty.deflateCoordinate)(flatCoordinates, 0, center, this.stride);
        flatCoordinates[offset++] = flatCoordinates[0] + radius;
        for(let i = 1, ii = this.stride; i < ii; ++i)flatCoordinates[offset++] = flatCoordinates[i];
        flatCoordinates.length = offset;
        this.changed();
    }
    getCoordinates() {
        return null;
    }
    setCoordinates(coordinates, layout) {}
    /**
   * Set the radius of the circle. The radius is in the units of the projection.
   * @param {number} radius Radius.
   * @api
   */ setRadius(radius) {
        this.flatCoordinates[this.stride] = this.flatCoordinates[0] + radius;
        this.changed();
    }
    /**
   * Rotate the geometry around a given coordinate. This modifies the geometry
   * coordinates in place.
   * @param {number} angle Rotation angle in counter-clockwise radians.
   * @param {import("../coordinate.js").Coordinate} anchor The rotation center.
   * @api
   */ rotate(angle, anchor) {
        const center = this.getCenter();
        const stride = this.getStride();
        this.setCenter((0, $1MAUi.rotate)(center, 0, center.length, stride, angle, anchor, center));
        this.changed();
    }
}
/**
 * Transform each coordinate of the circle from one coordinate reference system
 * to another. The geometry is modified in place.
 * If you do not want the geometry modified in place, first clone() it and
 * then use this function on the clone.
 *
 * Internally a circle is currently represented by two points: the center of
 * the circle `[cx, cy]`, and the point to the right of the circle
 * `[cx + r, cy]`. This `transform` function just transforms these two points.
 * So the resulting geometry is also a circle, and that circle does not
 * correspond to the shape that would be obtained by transforming every point
 * of the original circle.
 *
 * @param {import("../proj.js").ProjectionLike} source The current projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @param {import("../proj.js").ProjectionLike} destination The desired projection.  Can be a
 *     string identifier or a {@link module:ol/proj/Projection~Projection} object.
 * @return {Circle} This geometry.  Note that original geometry is
 *     modified in place.
 * @function
 * @api
 */ $f6170f1a08d72585$var$Circle.prototype.transform;
var $f6170f1a08d72585$export$2e2bcd8739ae039 = $f6170f1a08d72585$var$Circle;

});

parcelRegister("bV0pP", function(module, exports) {

$parcel$export(module.exports, "OLCS_ION_TOKEN", () => $8ad5571f7dcc7a1a$export$97f9922ccba1277f);
const $8ad5571f7dcc7a1a$export$97f9922ccba1277f = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJqdGkiOiI3ZWVhYmU0Mi1jNTZkLTQ3OGItYmUxYS00YTMyMDQyZTMwNDkiLCJpZCI6NjQ1LCJpYXQiOjE2MDYxMjE2OTF9.zQibbf5P0-moQ8KiV_K7KMtyLHbR-VlPghj8lyqWduU";

});


var $cc3xD = parcelRequire("cc3xD");

var $9DiKA = parcelRequire("9DiKA");

var $f3WAG = parcelRequire("f3WAG");

var $9jDAx = parcelRequire("9jDAx");

var $4mWlF = parcelRequire("4mWlF");

var $cJntk = parcelRequire("cJntk");

var $c3RIb = parcelRequire("c3RIb");

var $lrKvI = parcelRequire("lrKvI");

var $inIMS = parcelRequire("inIMS");

var $5DwXE = parcelRequire("5DwXE");

var $wnhPR = parcelRequire("wnhPR");

var $bnthu = parcelRequire("bnthu");

var $l7vEP = parcelRequire("l7vEP");

var $bdrRp = parcelRequire("bdrRp");

var $dIG9p = parcelRequire("dIG9p");

var $l7VLp = parcelRequire("l7VLp");

var $bV0pP = parcelRequire("bV0pP");
const $112deb77f5ea721f$var$image = new (0, $wnhPR.default)({
    radius: 5,
    fill: null,
    stroke: new (0, $lrKvI.default)({
        color: "red",
        width: 1
    })
});
const $112deb77f5ea721f$var$styles = {
    "Point": [
        new (0, $c3RIb.default)({
            image: $112deb77f5ea721f$var$image
        })
    ],
    "LineString": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "green",
                width: 2
            })
        })
    ],
    "MultiLineString": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "green",
                width: 2
            })
        })
    ],
    "MultiPoint": [
        new (0, $c3RIb.default)({
            image: $112deb77f5ea721f$var$image,
            text: new (0, $cJntk.default)({
                text: "MP",
                stroke: new (0, $lrKvI.default)({
                    color: "purple"
                })
            })
        })
    ],
    "MultiPolygon": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "yellow",
                width: 1
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(255, 255, 0, 0.1)"
            })
        })
    ],
    "Polygon": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "blue",
                width: 3
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(0, 0, 255, 0.1)"
            })
        })
    ],
    "GeometryCollection": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "magenta",
                width: 2
            }),
            fill: new (0, $inIMS.default)({
                color: "magenta"
            }),
            image: new (0, $wnhPR.default)({
                radius: 10,
                fill: null,
                stroke: new (0, $lrKvI.default)({
                    color: "magenta"
                })
            })
        })
    ],
    "Circle": [
        new (0, $c3RIb.default)({
            stroke: new (0, $lrKvI.default)({
                color: "red",
                width: 2
            }),
            fill: new (0, $inIMS.default)({
                color: "rgba(255,0,0,0.2)"
            })
        })
    ]
};
const $112deb77f5ea721f$var$styleFunction = function(feature, resolution) {
    const geo = feature.getGeometry();
    // always assign a style to prevent feature skipping
    return geo ? $112deb77f5ea721f$var$styles[geo.getType()] : $112deb77f5ea721f$var$styles["Point"];
};
const $112deb77f5ea721f$var$vectorSource = new (0, $bnthu.default)({
    format: new (0, $l7vEP.default)(),
    url: "data/geojson/ground_vector_data.geojson"
});
const $112deb77f5ea721f$var$vectorLayer = new (0, $bdrRp.default)({
    source: $112deb77f5ea721f$var$vectorSource,
    style: $112deb77f5ea721f$var$styleFunction
});
$112deb77f5ea721f$var$vectorLayer.getSource().addFeature(new (0, $dIG9p.default)({
    geometry: new (0, $l7VLp.default)([
        16880133.570042003,
        -3565441.544459192
    ], 200)
}));
const $112deb77f5ea721f$var$map = new (0, $5DwXE.default)({
    layers: [
        new (0, $4mWlF.default)({
            source: new (0, $9jDAx.default)()
        }),
        $112deb77f5ea721f$var$vectorLayer
    ],
    target: "map2d",
    controls: (0, $f3WAG.defaults)({
        attributionOptions: {
            collapsible: false
        }
    }),
    view: new (0, $9DiKA.default)({
        center: [
            16880670.33392873,
            -3565966.2275828626
        ],
        zoom: 15
    })
});
Cesium.Ion.defaultAccessToken = (0, $bV0pP.OLCS_ION_TOKEN);
$112deb77f5ea721f$var$vectorLayer.set("altitudeMode", "clampToGround");
const $112deb77f5ea721f$var$ol3d = new (0, $cc3xD.default)({
    map: $112deb77f5ea721f$var$map,
    target: "map3d"
});
const $112deb77f5ea721f$var$scene = $112deb77f5ea721f$var$ol3d.getCesiumScene();
Cesium.createWorldTerrainAsync().then((tp)=>$112deb77f5ea721f$var$scene.terrainProvider = tp);
$112deb77f5ea721f$var$ol3d.setEnabled(true);
window["toggleClampToGround"] = function() {
    let altitudeMode;
    if (!$112deb77f5ea721f$var$vectorLayer.get("altitudeMode")) altitudeMode = "clampToGround";
    $112deb77f5ea721f$var$vectorLayer.set("altitudeMode", altitudeMode);
    $112deb77f5ea721f$var$map.removeLayer($112deb77f5ea721f$var$vectorLayer);
    $112deb77f5ea721f$var$map.addLayer($112deb77f5ea721f$var$vectorLayer);
};
window["ol3d"] = $112deb77f5ea721f$var$ol3d;
window["scene"] = $112deb77f5ea721f$var$scene;
document.getElementById("enable").addEventListener("click", ()=>$112deb77f5ea721f$var$ol3d.setEnabled(!$112deb77f5ea721f$var$ol3d.getEnabled()));
$112deb77f5ea721f$var$ol3d.enableAutoRenderLoop();


//# sourceMappingURL=groundvectors.a70b75c6.js.map
